import Layout from "./Shared/Layout";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { decryptData } from "../_services/encDnc";
import { get, post } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import { syncCartAfterLogin } from "../redux/action";
import { ClipLoader } from 'react-spinners';
import { ToastContainer } from "react-toastify";
import OtpInput from "react-otp-input";

const Login = () => {
    const navigate = useNavigate();
    const [ph, setPh] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [loginDetail, setLoginDetail] = useState(null);
    const loginId = localStorage.getItem("loginId");
    const dispatch = useDispatch();
    const [userAddress, setUserAdderss] = useState([]);
    const [jwtToken, setJwtToken] = useState('')
    const [loading, setLoading] = useState(false);

    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail'));
    const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
    const priviousUrl = sessionStorage.getItem('priviousUrl');

    const GetUserAddressByLoginId = useCallback(async () => {
        if (loginId) {
            try {
                const response = await get(`${API_URL?.GetUserAddressByLoginId}?pLoginId=${loginId}`);
                const encryptedData = response.data;
                const result = decryptData(encryptedData);
                if (response.isSuccess === 200) {
                    setUserAdderss(result);
                }
            } catch (error) {
                setUserAdderss([]);
            }
        }
    }, [loginId]);

    useEffect(() => {
        GetUserAddressByLoginId();
    }, [GetUserAddressByLoginId]);

    // Login With Mobile Number and Otp
    const getLoginDetailByMobileNo = async (mobileNo) => {
        setLoading(true);
        try {
            const response = await post(API_URL.login, {
                mobileNo: mobileNo
            });

            if (response.isSuccess === 200) {
                const encryptedData = response.data;
                const result = decryptData(encryptedData);
                setLoginDetail(result[0]);
                const token = response.token;
                setJwtToken(token);
            }
            else {
                setLoginDetail(null);
            }
        } catch (error) {
            toast.error("Mobile number not registered");
        } finally {
            setLoading(false);
        }
    };

    const validatePhoneNumber = (phone) => {
        const isValid = /^\d{10}$/.test(phone) && parseInt(phone[0], 10);
        return isValid;
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');

        if (value !== numericValue) {
            alert("You can enter only numbers.");
        }

        setPh(numericValue.slice(0, 10));

        if (numericValue.length === 10) {
            getLoginDetailByMobileNo(numericValue);
        } else {
            setLoginDetail(null);
        }
    };

    useEffect(() => {
        if (ph) {
            getLoginDetailByMobileNo(ph);
        }
    }, [ph]);

    const sendOtp = async () => {
        if (ph === '') {
            toast.error('Please Enter Mobile Number');
            setLoading(false);
            return;
        }

        if (!validatePhoneNumber(ph)) {
            toast.error("Please enter a valid mobile number");
            setLoading(false);
            return;
        }

        const phoneNumber = ph.toString();

        if (!loginDetail) {
            toast.error("You are not registered");
            setLoading(false);
            sessionStorage.setItem('MobileNo', ph);
            setPh('');
            setTimeout(() => {
                navigate('/register');
            }, 1000);
            return;
        }

        setLoading(true);

        try {
            const response = await post(API_URL.SentOtp, {
                mobileNo: `${phoneNumber}`
            }, { timeout: 5000 });

            if (response.isSuccess === 200) {
                setShowOtpInput(true);
                toast.success("OTP Sent Successfully");
            }
        } catch (error) {
            toast.error("Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleOtpChange = (value) => {
        if (/^[0-9]*$/.test(value)) {
            setOtp(value);

        } else {
            toast.error("Please enter only numeric values for OTP.");
        }
    };

    useEffect(() => {
        if (otp.length === 6) {
            verifyOtp(otp);
        }
    }, [otp]);

    const verifyOtp = async () => {
        if (!otp) {
            toast.error("Please enter the OTP");
            return;
        }

        setLoading(true);

        try {
            const response = await post(API_URL.VerifyOTP, {
                mobileNo: `${ph}`,
                OTP: otp,
            });

            if (response.isSuccess === 200) {
                localStorage.setItem('jwtToken', jwtToken);
                localStorage.setItem('loginId', loginDetail.loginId);
                localStorage.setItem('isLoggedIn', true);
                toast.success("OTP Verified Successfully");
                setPh('');
                if (existingItemDetails) {
                    if (priviousUrl) {
                        navigate(`${priviousUrl}`);
                    } else {
                        if (userAddress.length > 0) {
                            navigate("/checkout");
                        } else {
                            navigate("/shipping-address");
                        }
                    }
                } else if (localCartData.length > 0 && localCartData != null) {
                    dispatch(syncCartAfterLogin());
                    if (priviousUrl) {
                        navigate(`${priviousUrl}`);
                    } else {
                        navigate('/cart');
                    }
                } else {
                    if (priviousUrl) {
                        navigate(`${priviousUrl}`);
                    } else {
                        navigate('/');
                    }
                }
            }
        } catch (error) {
            toast.error("Failed to Verify OTP");
        } finally {
            setLoading(false);
            setOtp("");
        }
    };

    const onResendOtp = () => {
        setOtp("");
        sendOtp();
    }

    const onRegister = ()=>{
        sessionStorage.removeItem('MobileNo');
        navigate('/register');
    }

    return (
        <Layout>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <section className="userlogin">
                <div className="all_cente_login user_login_weppwe_main">
                    <div className="container">
                        <div className="row justify-content-between user_login_wepper">
                            <div className="col-lg-6 col-md-6 col-12">
                                <div className="left_side_img_data user_login_weppwe_main">
                                    <img src="./images/login_left.png" alt="" className="w-100" />
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6 col-12 d-flex align-items-center">
                                <div className="userloginform">
                                    <div className="userform-heading">
                                        <h4>Login</h4>
                                    </div>
                                    <form>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                {showOtpInput ? (
                                                    <div className="otp_input form-outline mb-3 d-flex justify-content-center">
                                                        <OtpInput
                                                            className="otpinput justify-content-center"
                                                            value={otp}
                                                            onChange={handleOtpChange}
                                                            numInputs={6}
                                                            renderSeparator={<span>-</span>}
                                                            renderInput={(props) => <input {...props} />}
                                                        />
                                                    </div>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        name="mobileNo"
                                                        id="mobileNo"
                                                        placeholder="Enter Mobile Number"
                                                        value={ph}
                                                        onChange={handleMobileChange}
                                                        disabled={showOtpInput}
                                                        style={{ flex: 1 }}
                                                        maxLength={10}
                                                        className="form-control"
                                                    />
                                                )}
                                            </div>
                                            <div className="col-lg-12 user-loginbtn">
                                                <button
                                                    type="submit"
                                                    className="otp_btn"
                                                    onClick={showOtpInput ? verifyOtp : sendOtp}
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <ClipLoader color="#fff" size={20} />
                                                    ) : (
                                                        showOtpInput ? 'Verify OTP' : 'Send OTP'
                                                    )}
                                                </button>
                                            </div>
                                            <div className="userformlinks mt-2">
                                                <span>Don't have an account?</span>
                                                <span onClick={onRegister} className="register_color cursor-pointer" >
                                                    Register
                                                </span>
                                            </div>
                                            {showOtpInput && (
                                                <div className="userformlinks mt-2">
                                                    <span onClick={onResendOtp} className="resend_otp_button">
                                                        Resend OTP
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout >
    );
};

export default Login;
